import { Text, TextProps } from '@chakra-ui/react';
import React from 'react';


interface SimpleDescriptionProps extends TextProps {
  label: string;
  description: string;
}

export const SimpleDescription = ({ description, label, ...textProps }: SimpleDescriptionProps) => {
  return (<Text color="neutral.800" {...textProps}>{label}: {description}</Text>);
};
